<pr-tag-list
  [tags]="appointmentTags$ | async"
  (tagAdded)="addTag($event)"
 />
